export interface ExtractedImage {
	contentId: string;
	filename: string;
	mimeType: string;
	data: Uint8Array;
}

export interface ExtractionResult {
	html: string;
	images: ExtractedImage[];
}

const DATA_URI_RE = /^data:(image\/(?:png|jpeg|gif|webp));base64,(.+)$/i;

function base64ToUint8Array(base64: string): Uint8Array {
	const binary = atob(base64);
	const bytes = new Uint8Array(binary.length);
	for (let i = 0; i < binary.length; i++) {
		bytes[i] = binary.charCodeAt(i);
	}
	return bytes;
}

function generateContentId(): string {
	const id = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
	return `${id}@composer`;
}

const MIME_TO_EXT: Record<string, string> = {
	'image/png': 'png',
	'image/jpeg': 'jpg',
	'image/gif': 'gif',
	'image/webp': 'webp',
};

export function extractInlineImages(html: string): ExtractionResult {
	const images: ExtractedImage[] = [];
	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');
	const imgElements = doc.querySelectorAll('img');

	imgElements.forEach(img => {
		const src = img.getAttribute('src');
		if (!src) return;

		const match = DATA_URI_RE.exec(src);
		if (!match) return;

		const mimeType = match[1]!;
		const base64Data = match[2]!;
		const contentId = generateContentId();
		const ext = MIME_TO_EXT[mimeType] ?? 'png';

		images.push({
			contentId,
			filename: `inline-${contentId}.${ext}`,
			mimeType,
			data: base64ToUint8Array(base64Data),
		});

		img.setAttribute('src', `cid:${contentId}`);
	});

	const serializer = new XMLSerializer();
	const body = doc.body;
	const resultHtml = body ? serializer.serializeToString(body).replace(/^<body[^>]*>|<\/body>$/gi, '') : html;

	return {html: images.length > 0 ? resultHtml : html, images};
}
